module.exports = __webpack_public_path__ + "img/march-4.c79dbd6d.png";